import React from 'react';
import styled from 'styled-components';
import { Pagination } from 'planoplan-ui-kit/core/pagination';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { Points, marginLevel } from '@styles';
import { useTranslations } from '@libs/translations';

export const Bottom = ({ pageCount = 0, currentPage = 1, onChangePage = () => {} }) => {
  const isMobileOnly = useMediaQuery(Points.mobile_only, { useSSR: true });
  const translations = useTranslations();

  if (pageCount <= 1) {
    return null;
  }

  return (
    <Container>
      <Pagination
        current={currentPage}
        count={pageCount}
        theme={isMobileOnly ? 'column' : 'row'}
        useScroll={true}
        name={{ back: translations.t('site.common.back'), next: translations.t('site.common.next') }}
        device={{ isMobile: deviceDetected.isMobile }}
        onChange={onChangePage}
      />
    </Container>
  );
};

const Container = styled.div`
  ${marginLevel('top', 'colar')};
  display: flex;
  justify-content: center;
`;
